import { useTranslation } from "react-i18next";
import {A} from "../../shared/components/Typograhy";
import {faExternalLinkAlt} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Modal from "../../shared/components/Modal";
import {Alert} from "../../shared/components/Alert";
import {generate} from "../../../routing/routes";
import {serviceName} from "../../../data/booking/constants/service_types";
import moment from "moment/moment";
import {ArrowLongRightIcon} from "@heroicons/react/24/outline";
import React from "react";
import {NextButton} from "../../shared/components/Buttons";
import {useNavigate} from "react-router-dom";

export default function MatchingBookingAlert ({bookings, setOpen}){
    const { t } = useTranslation();
    const navigate = useNavigate()

    return <Modal
            title={t('booking.matching.title')}
            open={bookings != false}
            setOpen={setOpen}
        >
        <Alert alert="warning" className="my-8 flex flex-col gap-y-4">
            <p>{t('booking.matching.description.part1')}</p>
            <p>{t('booking.matching.description.part2')}</p>
        </Alert>
        <div className="mb-10">
            {bookings && bookings.map(booking => <div key={booking.reference} className="gap-x-3 py-4 flex flex-col gap-y-2 sm:flex-row items-center border-t border-b border-gray-200 mb-2">
                <div>
                    {t('booking.'+booking.type)}<br />
                    <A target={"_blank"} href={generate('customer_reservation', {reference: booking.reference})}>#{booking.reference}</A>

                </div>
                <div className="flex-1 border-0 sm:border-l border-gray-200 pl-3 ">
                    <div className="flex gap-x-2 justify-center sm:justify-start ">
                        {booking.hikes.join(' - ')}
                        <div>
                            <div className="flex flex-wrap items-center">
                                <span>{moment(booking.startAt).format('DD MMM')}</span>
                                {booking.startAt != booking.endAt && <>
                                    <ArrowLongRightIcon className="h-4 w-4" aria-hidden="true"/>
                                    <span>{moment(booking.endAt).format('DD MMM')}</span>
                                </>}
                            </div>
                        </div>
                    </div>
                    <p className="text-sm text-gray-600">{booking.services.map(service => serviceName(service)).join(" · ")}</p>
                </div>
                <div className="flex-0">
                    <NextButton onClick={() => navigate(generate('book_edit', {'reference': booking.reference}))}>Modifier</NextButton>
                </div>
            </div>)}
        </div>
    </Modal>
}
